import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import { BaseResponse } from "../../../shared/types";
import {
  PendingApplicationsResponse,
  RejectApplicationRequest,
  InvitationRequestsResponse,
  CreateInvitationCodeResponse,
  InvitationLogsResponse,
  ApproveApplicationRequest,
} from "./types";

export const joiningApi = createApi({
  reducerPath: "joiningApi",
  baseQuery: baseApiQuery,
  tagTypes: ["JoiningApplications"],
  endpoints: (builder) => ({
    getPendingApplications: builder.query<PendingApplicationsResponse, void>({
      query: () => "/admin/joining/applications/pending",
      providesTags: ["JoiningApplications"],
    }),

    getInvitationRequests: builder.query<InvitationRequestsResponse, void>({
      query: () => "/admin/joining/invitation/requests",
      providesTags: ["JoiningApplications"],
    }),

    createInvitationCode: builder.mutation<
      CreateInvitationCodeResponse,
      number
    >({
      query: (id) => ({
        url: `/admin/joining/invitation/${id}/create-invitation-code`,
        method: "POST",
      }),
      invalidatesTags: ["JoiningApplications"],
    }),

    approveApplication: builder.mutation<
      BaseResponse,
      ApproveApplicationRequest
    >({
      query: ({ id, caliber }) => ({
        url: `/admin/joining/applications/${id}/approve`,
        method: "POST",
        body: { caliber },
      }),
      invalidatesTags: ["JoiningApplications"],
    }),

    rejectApplication: builder.mutation<
      BaseResponse,
      { id: string; body: RejectApplicationRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/joining/applications/${id}/reject`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["JoiningApplications"],
    }),

    getInvitationLogs: builder.query<InvitationLogsResponse, string>({
      query: (userId) => ({
        url: "/admin/joining/invitation/logs",
        params: { userId },
      }),
      providesTags: ["JoiningApplications"],
    }),
  }),
});

export const {
  useGetPendingApplicationsQuery,
  useGetInvitationRequestsQuery,
  useCreateInvitationCodeMutation,
  useApproveApplicationMutation,
  useRejectApplicationMutation,
  useGetInvitationLogsQuery,
} = joiningApi;
